import { render } from "./PedidoDetalhe.vue?vue&type=template&id=626c2ba2&scoped=true&ts=true"
import script from "./PedidoDetalhe.vue?vue&type=script&lang=ts"
export * from "./PedidoDetalhe.vue?vue&type=script&lang=ts"

import "./PedidoDetalhe.vue?vue&type=style&index=0&id=626c2ba2&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626c2ba2"]])

export default __exports__